export default "__VITE_ASSET__1AT7W_AX__"